import { CreditCardEncryptedModel } from 'types/models'
import { CreditCardEncryptedDto } from 'types/dtos'

export const transformCreditCardEncryptedModel = ({
  cardNumber,
  expirationMonth,
  expirationYear,
  cvc,
}: CreditCardEncryptedModel): CreditCardEncryptedDto => ({
  number: cardNumber,
  expiration_month: expirationMonth,
  expiration_year: expirationYear,
  security_code: cvc,
})
